import { styled } from '@mui/material';

export const LogoWrapper = styled('div')`
  height: 130px;
  display: flex;
  align-items: end;
  margin-left: 100px;
`;
